import { format, isValid, parseISO } from 'date-fns'

import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../constants/date'
import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../constants/rentalPortal'
import { toUkTimezoneDate } from '../../../../utils/date'

import { MATCH_PROVENANCE_TEXT_KEY } from './RentalPortalMatchProvenanceDot.constants'

export function getMatchProvenanceTooltip({ provenance, t, timezone }) {
  const at = provenance.at ? parseISO(provenance.at) : null

  return [
    t(MATCH_PROVENANCE_TEXT_KEY[provenance.source]),
    at && isValid(at)
      ? format(toUkTimezoneDate(at, timezone), DATE_FULL_FORMAT_FROM_TIME)
      : null,
  ]
    .filter(Boolean)
    .join(RENTAL_PORTAL_FACT_SEPARATOR)
}
